<template>
  <div id="contenedor">
    <v-layout row wrap>
      <v-flex xs11 class="offset-half">
        <v-card class="table" elevation="4">
          <v-toolbar flat elevation="4">
            <v-card class="icon">
              <v-icon
                style="margin-left: 30px; margin-top: 25px"
                color="white"
                x-large=""
                >mdi-folder-clock-outline</v-icon
              >
            </v-card>
            <div class="usuario">ASIGNADOS</div>
            <!-- Botón de actualizar manual -->
            <!-- Botón de actualizar manual -->
            <v-btn
              color="#1D3C7F"
              @click="obtenerCasos"
              class="ml-5 update-btn"
              style="color: white; font-weight: bold"
              :loading="loadingObtenerCasos"
              :disabled="loadingObtenerCasos"
            >
              <template v-if="!loadingObtenerCasos">
                <v-icon size="28px">mdi-refresh</v-icon>
              </template>
              <template v-else>
                <v-progress-circular
                  indeterminate
                  color="white"
                  size="24"
                ></v-progress-circular>
              </template>
            </v-btn>
            <v-spacer></v-spacer>

            <!-- 🟢 NUEVO: Filtro específico para Gestión Humana (solo si el usuario es de Facilisimo y área 3) -->
            <div v-if="idAreaUsuario === 3 && idEmpresaUsuario === 1" class="filter-container mr-3">
              <v-select
                v-model="filtroGestionHumana"
                :items="opcionesGestionHumana"
                item-text="text"
                item-value="value"
                label="Filtrar por"
                outlined
                dense
                style="max-width: 150px; font-size: 13.5px"
                @change="aplicarFiltroGestionHumana"
              ></v-select>
            </div>

            <!-- Filtro para cambiar vista -->
            <div class="filter-container">
              <!-- Select normal para pantallas grandes -->
              <v-select
                v-if="!$vuetify.breakpoint.xs"
                v-model="selectedFilter"
                :items="filterOptions"
                item-text="text"
                item-value="value"
                label="Cambiar vista"
                outlined
                dense
                style="max-width: 150px; font-size: 13.5px"
                @change="changeFilter"
              ></v-select>

              <!-- Solo icono para pantallas pequeñas -->
              <v-menu
                v-if="$vuetify.breakpoint.xs"
                v-model="showFilterMenu"
                :close-on-content-click="false"
                offset-y
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on" class="filter-icon-btn">
                    <v-icon>mdi-filter-variant</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-for="option in filterOptions"
                    :key="option.value"
                    @click="selectFilterOption(option.value)"
                  >
                    <v-list-item-title>{{ option.text }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>

            <!-- Modal para cerrar caso -->
            <v-dialog v-model="dialog3" max-width="500px" persistent>
              <v-card>
                <v-card-title class="nav">
                  <span class="headline" style="color: white">
                    <v-icon color="white">mdi-folder-remove-outline</v-icon>
                    Cerrar caso
                  </span>
                </v-card-title>
                <v-card-text>
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12 sm12 md12>
                        <v-text-field
                          v-model="editedItem3.Observaciones"
                          label="Observaciones"
                          :rules="observacionesRules"
                          required
                        ></v-text-field>
                        <!-- INICIO componente del modal agregar varios archivos -->
                        <div
                          id="drop-area"
                          @dragover.prevent
                          @dragenter.prevent
                          @drop.prevent="handleDropMultiple"
                          @paste.prevent="handlePasteMultiple"
                        >
                          <div v-if="previewImages.length">
                            <div
                              v-for="(img, idx) in previewImages"
                              :key="idx"
                              style="margin-bottom: 8px"
                            >
                              <img
                                :src="img"
                                alt="Vista previa"
                                style="max-width: 100px; max-height: 100px"
                              />
                            </div>
                          </div>
                          <div v-if="selectedFiles.length">
                            <div
                              v-for="(file, idx) in selectedFiles"
                              :key="idx"
                              style="margin-bottom: 8px"
                            >
                              <v-icon color="primary" v-if="!isImageFile(file)"
                                >mdi-file</v-icon
                              >
                              <span>{{ file.name }}</span>
                            </div>
                          </div>
                          <span
                            v-if="
                              !previewImages.length && !selectedFiles.length
                            "
                          >
                            Arrastra y suelta o copia y pega archivos aquí
                            (Word, Excel, PDF, imágenes) Maximo 5 archivos
                          </span>
                        </div>
                        <input
                          type="file"
                          ref="fileInput"
                          @change="handleFileChangeMultiple"
                          style="display: none"
                          multiple
                          accept=".jpg,.jpeg,.png,.gif,.webp,.svg,.jfif,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.csv,.odt,.ods,.odp,.rtf,.zip,.rar"
                        />
                        <button @click="openFileInput" class="upload-button">
                          Seleccionar Archivos
                        </button>
                        <!-- FIN componente del modal agregar varios archivos -->
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="#1D3C7F" dark @click="close3">CANCELAR</v-btn>
                  <v-btn
                    color="#1D3C7F"
                    dark
                    @click="save3(idCaso)"
                    :disabled="!isObservacionValida"
                    >CERRAR CASO</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
            <!-- Modal para historial -->
            <CaseHistoryTimeline
              v-if="idCasoActual !== null"
              :caseId="idCasoActual"
              :visible.sync="dialogHistorial"
            />
            <!-- Modal para cambiar estado (suspender/anular/reasignar) -->
            <v-dialog v-model="dialog6" max-width="600px" persistent>
              <v-card>
                <v-card-title class="nav">
                  <span class="headline" style="color: white">
                    <v-icon color="white">mdi-pencil</v-icon>
                    Cambiar estado
                  </span>
                </v-card-title>

                <v-card-text>
                  <v-layout wrap>
                    <v-flex xs12 class="mt-5">
                      <v-select
                        color="#294697"
                        v-model="editedItem.estado"
                        :items="[
                          'SUSPENDIDO',
                          'ANULADO',
                          'REASIGNAR',
                          'DESASIGNAR',
                        ]"
                        label="Selecciona cambio de estado"
                        persistent-hint
                        outlined
                      ></v-select>

                      <!-- Campo de observaciones para suspender/anular -->
                      <v-text-field
                        v-if="
                          editedItem.estado !== 'REASIGNAR' &&
                          editedItem.estado !== 'DESASIGNAR'
                        "
                        v-model="editedItem.observacion"
                        label="Observaciones"
                        outlined
                        class="mt-4"
                      ></v-text-field>

                      <!-- Campos para reasignación -->
                      <div
                        v-if="editedItem.estado === 'REASIGNAR'"
                        class="mt-4"
                      >
                        <v-select
                          v-model="especialistaSeleccionado"
                          :items="especialistasDisponibles"
                          item-text="nombre"
                          item-value="idUsuario"
                          label="Seleccionar especialista"
                          outlined
                          color="#294697"
                          :loading="cargandoEspecialistas"
                        ></v-select>
                        <v-text-field
                          v-model="observacionReasignacion"
                          label="Observaciones de reasignación"
                          outlined
                          class="mt-4"
                          placeholder="Motivo de la reasignación..."
                        ></v-text-field>
                      </div>

                      <!-- Campos para desasignación -->
                      <div
                        v-if="editedItem.estado === 'DESASIGNAR'"
                        class="mt-4"
                      >
                        <v-text-field
                          v-model="observacionReasignacion"
                          label="Observaciones de desasignación"
                          outlined
                          class="mt-4"
                          placeholder="Motivo de la desasignación..."
                        ></v-text-field>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="#1D3C7F" dark @click="close6">CANCELAR</v-btn>
                  <v-btn
                    color="#1D3C7F"
                    dark
                    @click="guardarEstado"
                    :disabled="
                      !editedItem.estado ||
                      (editedItem.estado === 'REASIGNAR' &&
                        !especialistaSeleccionado)
                    "
                  >
                    GUARDAR
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
          <br />
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar caso asignado"
            class="text-field"
            single-line
            color="#111c3d"
          ></v-text-field>
          <br />
          <v-data-table
            :headers="headers"
            :items="casosFiltrados"
            :search="search"
            v-model="casosSeleccionados"
            show-select
            item-key="cc_id_caso"
            style="border: 2px solid #111c3d"
            class="elevation-3"
            must-sort
          >
            <template v-slot:[`item.cc_id_asesor`]="{ item }">
              <div class="d-flex align-center">
                <v-icon
                  color="primary"
                  @click="handleAsesor(item.infoAsesor)"
                  class="mr-2"
                >
                  mdi-account-tie
                </v-icon>
                <v-icon color="purple" @click="verHistorial(item)" class="ml-1">
                  mdi-timeline-clock
                </v-icon>
              </div>
            </template>
            <template v-slot:footer.prepend>
              <v-btn
                color="#1D3C7F"
                class="acciones-masivas-btn"
                :disabled="casosSeleccionados.length < 2"
                @click="abrirModalAccionMasiva"
                style="color: whitesmoke; font-weight: bold"
                large
              >
                <v-icon left style="color: whitesmoke"
                  >mdi-playlist-edit</v-icon
                >
                ACCIONES MASIVAS
              </v-btn>
            </template>
            <!-- tabla donde se pintan los datos obtenidos del arreglo -->
            <template v-slot:[`item.semaforo`]="{ item }">
              <SemaforoTiempo
                :fecha-inicio="item.fecha_area"
                :dias="requerimientosInfo[item.cc_id_requerimiento]?.dias || 0"
                :horas="
                  requerimientosInfo[item.cc_id_requerimiento]?.horas || 0
                "
                :minutos="
                  requerimientosInfo[item.cc_id_requerimiento]?.minutos || 0
                "
                :id-caso="item.cc_id_caso"
                :tiempo-restante-backend="item.tiempoRestanteBackend"
                :estado-caso="item.estado_caso"
                :dias-festivos="diasFestivos"
                @caso-vencido="handleCasoVencido"
              />
            </template>
            <template v-slot:[`item.cc_prioridad_requerimiento`]="{ item }">
              <div v-if="item.cc_prioridad_requerimiento === '3'">
                <v-chip outlined class="ma-2" :color="item.color">
                  ALTA
                </v-chip>
              </div>
              <div v-if="item.cc_prioridad_requerimiento === '2'">
                <v-chip outlined class="ma-2" :color="item.color">
                  MEDIA
                </v-chip>
              </div>
              <div v-if="item.cc_prioridad_requerimiento === '1'">
                <v-chip outlined class="ma-2" :color="item.color">
                  BAJA
                </v-chip>
              </div>
            </template>
            <template v-slot:[`item.action`]="{ item }">
              <v-icon
                color="light-blue darken-4"
                class="mr-2"
                @click="verConversacion(item)"
              >
                mdi-wechat
              </v-icon>
              <v-icon color="red" class="mr-2" @click="cerrarCaso(item)">
                mdi-folder-remove-outline
              </v-icon>
              <v-icon color="green" class="mr-2" @click="cambiarEstado(item)">
                mdi-cog-clockwise
              </v-icon>
              <v-icon
                color="orange"
                class="mr-2"
                @click="abrirAgregarObservacion(item)"
              >
                mdi-comment-plus
              </v-icon>
            </template>
            <template v-slot:no-data>
              <v-alert :value="true" color="#111c3d" icon="mdi-alert" outlined
                >No se encontro su busqueda</v-alert
              >
            </template>
          </v-data-table>
          <!-- Dialog que permite visualizar la conversacion -->
          <v-dialog v-model="dialog2" max-width="500px" persistent>
            <v-card>
              <v-card-title class="nav">
                <span class="headline" style="color: white"
                  ><v-icon color="white">mdi-message-bulleted</v-icon>
                  Conversación</span
                >
              </v-card-title>
              <!-- componente del modal para agregar y actualizar -->
              <v-card-text>
                <div v-for="(chat, index) in chatItem" :key="index">
                  <v-card class="mt-3 mx-auto" width="550">
                    <v-card-subtitle v-if="chat.user == 'NOVA'" class="pb-0">
                      <p class="indigo--text text--darken-3">
                        <v-icon color="indigo darken-4" class="ml-5 mr-1"
                          >mdi-robot</v-icon
                        >{{ chat.user }}
                      </p>
                    </v-card-subtitle>
                    <v-card-subtitle v-else class="d-flex justify-end">
                      <p class="deep-purple--text text--accent-3">
                        <v-icon color="deep-purple accent-4" class="ml-5 mr-1"
                          >mdi-face</v-icon
                        >{{ chat.user }}
                      </p>
                    </v-card-subtitle>
                    <v-card-text v-if="chat.user == 'NOVA'" class="">
                      <p
                        class="grey--text text--darken-1 text-left chat-message"
                      >
                        {{ chat.message }}
                      </p>
                    </v-card-text>
                    <v-card-text v-else class="d-flex justify-end">
                      <p
                        class="grey--text text--darken-1 text-right chat-message"
                      >
                        {{ chat.message }}
                      </p>
                    </v-card-text>
                  </v-card>
                </div>
                <v-divider class="mt-5"></v-divider>
              </v-card-text>
              <!-- botones para cancelar y agregregar y validacion de campos vacios -->
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="#1D3C7F"
                  dark
                  @click="verEvidencias(idCasoActual)"
                  class="mr-2"
                >
                  <v-icon left>mdi-image-multiple</v-icon>
                  VER EVIDENCIAS
                </v-btn>
                <v-btn color="#1D3C7F" dark @click="close2">CERRAR</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- alertas de las acciones que se hacen -->
          <v-snackbar
            v-model="snackbar"
            :bottom="false"
            :left="false"
            :multi-line="mode === 'multi-line'"
            :right="false"
            :timeout="timeout"
            :top="true"
            :vertical="false"
            color="#294697"
            class="snackbar-superior"
            absolute
            style="color: white"
          >
            {{ text }}
            <v-btn color="#294697" dark depressed @click="snackbar = false"
              >Cerrar</v-btn
            >
          </v-snackbar>

          <!-- Modal para ver las evidencias del caso -->
          <v-dialog v-model="dialogEvidencias" max-width="900px">
            <v-card>
              <v-card-title class="nav">
                <span class="headline" style="color: white">
                  <v-icon color="white">mdi-image-multiple</v-icon>
                  Evidencias del caso #{{ idCasoActual }}
                </span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <div v-if="cargandoEvidencias" class="text-center my-5">
                    <v-progress-circular
                      indeterminate
                      color="#294697"
                    ></v-progress-circular>
                    <p>Cargando evidencias...</p>
                  </div>
                  <div v-else-if="!evidencias.length" class="text-center my-5">
                    <v-alert type="info" outlined>
                      No hay evidencias disponibles para este caso.
                    </v-alert>
                  </div>
                  <v-row v-else>
                    <v-col
                      v-for="(evidencia, index) in evidencias"
                      :key="index"
                      cols="12"
                      sm="6"
                      md="4"
                    >
                      <v-card outlined>
                        <template
                          v-if="isImageUrl(evidencia.cc_ruta_evidencia)"
                        >
                          <v-img
                            :src="evidencia.cc_ruta_evidencia"
                            aspect-ratio="1"
                            class="grey lighten-2"
                            @click="
                              verImagenCompleta(evidencia.cc_ruta_evidencia)
                            "
                            style="cursor: pointer"
                          >
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                              >
                                <v-progress-circular
                                  indeterminate
                                  color="#294697"
                                ></v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </template>
                        <template v-else>
                          <v-card
                            class="d-flex flex-column align-center justify-center pa-3"
                            style="
                              cursor: pointer;
                              aspect-ratio: 1;
                              height: 100%;
                            "
                            @click="downloadFile(evidencia.cc_ruta_evidencia)"
                          >
                            <v-icon size="80" color="grey darken-1"
                              >mdi-file-document-outline</v-icon
                            >
                            <div
                              class="mt-2 text-caption grey--text text--darken-1 text-center"
                              style="word-break: break-all"
                            >
                              {{ getFileName(evidencia.cc_ruta_evidencia) }}
                            </div>
                          </v-card>
                        </template>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#1D3C7F" dark @click="closeEvidencias"
                  >CERRAR</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!-- Modal para ver una imagen en pantalla completa -->
          <v-dialog v-model="dialogImagenCompleta" max-width="90vw" fullscreen>
            <v-card flat>
              <v-toolbar dark color="#1D3C7F" flat>
                <v-btn icon dark @click="descargarImagen">
                  <v-icon>mdi-download</v-icon>
                </v-btn>
                <v-toolbar-title>Evidencia</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark @click="dialogImagenCompleta = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text
                class="pa-0 d-flex justify-center align-center"
                style="height: calc(100vh - 64px); background-color: #000"
              >
                <img
                  :src="imagenSeleccionada"
                  style="max-height: 95vh; max-width: 95vw; object-fit: contain"
                />
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- El modal de acción masiva debe estar aquí dentro -->
    <v-dialog v-model="dialogAccionMasiva" max-width="600px" persistent>
      <v-card>
        <v-card-title class="nav">
          <span class="headline" style="color: white">
            <v-icon color="white">mdi-playlist-edit</v-icon>
            Acción masiva sobre casos seleccionados
          </span>
        </v-card-title>
        <v-card-text>
          <div class="acciones-masivas-list">
            <v-btn
              v-for="accion in accionesMasivas"
              :key="accion.key"
              :color="accion.color"
              class="accion-masiva-opcion"
              :class="{
                'accion-masiva-opcion--active':
                  accionSeleccionada === accion.key,
              }"
              @click="seleccionarAccionMasiva(accion.key)"
              large
            >
              <v-icon left>{{ accion.icon }}</v-icon>
              {{ accion.label }}
            </v-btn>
          </div>
          <div v-if="accionSeleccionada">
            <div v-if="accionSeleccionada === 'reasignar'">
              <p style="font-size: 18px; color: black; margin-top: 24px">
                ¿A qué especialista desea reasignar estos casos?
              </p>
              <v-select
                v-model="especialistaSeleccionado"
                :items="especialistasDisponibles"
                item-text="nombre"
                item-value="idUsuario"
                label="Seleccionar especialista"
                outlined
                color="#294697"
                :loading="cargandoEspecialistas"
                class="mt-4"
              ></v-select>
              <v-text-field
                v-model="observacionReasignacion"
                label="Observaciones de reasignación"
                outlined
                class="mt-4"
                placeholder="Motivo de la reasignación..."
              ></v-text-field>
            </div>
            <div v-else-if="accionSeleccionada === 'cerrar'">
              <p style="font-size: 18px; color: black; margin-top: 24px">
                ¿Está seguro que desea cerrar estos casos?
              </p>
              <v-text-field
                v-model="masivoObservaciones"
                label="Observaciones"
                outlined
                class="mt-4"
                :rules="observacionesRules"
                required
              />
              <!-- INICIO componente del modal agregar varios archivos -->
              <div
                id="drop-area"
                @dragover.prevent
                @dragenter.prevent
                @drop.prevent="handleDropMultiple"
                @paste.prevent="handlePasteMultiple"
                style="margin-top: 16px"
              >
                <div v-if="previewImages.length">
                  <div
                    v-for="(img, idx) in previewImages"
                    :key="idx"
                    style="margin-bottom: 8px"
                  >
                    <img
                      :src="img"
                      alt="Vista previa"
                      style="
                        max-width: 100px;
                        max-height: 100px;
                        display: block;
                        margin: 0 auto;
                      "
                    />
                  </div>
                </div>
                <div v-if="selectedFiles.length">
                  <div
                    v-for="(file, idx) in selectedFiles"
                    :key="idx"
                    style="margin-bottom: 8px"
                  >
                    <v-icon color="primary" v-if="!isImageFile(file)"
                      >mdi-file</v-icon
                    >
                    <span>{{ file.name }}</span>
                  </div>
                </div>
                <span v-if="!previewImages.length && !selectedFiles.length">
                  Arrastra y suelta o copia y pega archivos aquí (Word, Excel,
                  PDF, imágenes)
                </span>
              </div>
              <input
                type="file"
                ref="fileInput"
                @change="handleFileChangeMultiple"
                style="display: none"
                multiple
                accept=".jpg,.jpeg,.png,.gif,.webp,.svg,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.csv,.odt,.ods,.odp,.rtf,.zip,.rar"
              />
              <button
                @click="openFileInput"
                class="upload-button"
                style="margin-top: 8px"
              >
                Seleccionar Archivos
              </button>
              <!-- FIN componente del modal agregar varios archivos -->
            </div>
            <div v-else-if="accionSeleccionada === 'suspender'">
              <p style="font-size: 18px; color: black; margin-top: 24px">
                ¿Por qué desea suspender estos casos?
              </p>
              <v-text-field
                v-model="masivoMotivo"
                label="Motivo"
                outlined
                class="mt-4"
              />
              <v-menu
                ref="menuSusp"
                v-model="menuSusp"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <!-- <v-text-field
                  v-model="masivoFechaSuspension"
                  label="Fecha de suspensión"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  class="mt-4"
                ></v-text-field> -->
              </v-menu>
            </div>
            <div v-else-if="accionSeleccionada === 'anular'">
              <p style="font-size: 18px; color: black; margin-top: 24px">
                ¿Por qué desea anular estos casos?
              </p>
              <v-text-field
                v-model="masivoMotivo"
                label="Motivo"
                outlined
                class="mt-4"
              />
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#1D3C7F" dark @click="dialogAccionMasiva = false"
            >CANCELAR</v-btn
          >
          <v-btn
            color="#1D3C7F"
            :disabled="
              !accionSeleccionada ||
              (accionSeleccionada === 'cerrar' && !isObservacionMasivaValida) ||
              ((accionSeleccionada === 'suspender' ||
                accionSeleccionada === 'anular') &&
                !masivoMotivo) ||
              (accionSeleccionada === 'reasignar' && !especialistaSeleccionado)
            "
            dark
            @click="confirmarAccionMasiva"
            >CONFIRMAR</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogAgregarObservacion" max-width="500px">
      <v-card>
        <v-card-title>Agregar Observación</v-card-title>
        <v-card-text>
          <v-textarea
            class="pt-5"
            v-model="nuevaObservacion"
            label="Observación"
            rows="2"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogAgregarObservacion = false">Cancelar</v-btn>
          <v-btn color="primary" @click="guardarObservacion">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <CaseHistoryTimeline
      v-if="idCasoActual !== null"
      :caseId="idCasoActual"
      :visible.sync="dialogHistorialObservaciones"
      :soloObservaciones="true"
    />
    <!-- MODAL DEL ASESOR -->
    <v-dialog
      class="dialogAsesor"
      v-model="showDialogAsesor"
      persistent
      max-width="400"
    >
      <v-card class="mx-auto" max-width="400" outlined>
        <v-list-item three-line>
          <v-list-item-content>
            <div class="text-overline mb-4">INFO. ASESOR</div>
            <v-list-item-title class="text-h6 mb-2">
              {{ objAsesor.nombre }}
            </v-list-item-title>
            <v-list-item-subtitle class="mb-2 mt-2">
              <v-icon class="mr-2" size="19">mdi-card-account-details</v-icon>
              {{ objAsesor.cedula }}
            </v-list-item-subtitle>
            <v-list-item-subtitle>
              <v-icon class="mr-2" size="20">mdi-phone</v-icon>
              {{ objAsesor.telefono }}
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-avatar size="80" color="blue" rounded="50">
            <v-icon size="60" color="white"> mdi-account-tie </v-icon>
          </v-list-item-avatar>
        </v-list-item>
        <v-card-actions>
          <v-btn
            color="primary"
            elevation="2"
            outlined
            raised
            class="ms-auto"
            @click="showDialogAsesor = false"
            >Cerrar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- /MODAL DEL ASESOR -->
  </div>
</template>

<script>
import axios from "axios";
import env from "../../env";
import SemaforoTiempo from "./SemaforoTiempo.vue";
import CaseHistoryTimeline from "./CaseHistoryTimeline.vue";
export default {
  components: {
    CaseHistoryTimeline,
    SemaforoTiempo,
  },
  data() {
    return {
      // Propiedades para el filtro
      selectedFilter: "asignados",
      showFilterMenu: false,
      filterOptions: [
        { text: "TICKETS", value: "tickets" },
        { text: "PENDIENTES", value: "pendientes" },
        { text: "ASIGNADOS", value: "asignados" },
        { text: "SUSPENDIDOS", value: "suspendidos" },
        { text: "CERRADOS", value: "cerrados" },
      ],

      // 🟢 NUEVO: Filtro específico para Gestión Humana
      filtroGestionHumana: "todos",
      opcionesGestionHumana: [
        { text: "Todos", value: "todos" },
        { text: "Nómina", value: "nomina" },
        { text: "Bienestar", value: "bienestar" },
        { text: "SST", value: "sst" },
        { text: "Capacitación", value: "capacitacion" },
      ],

      // Ids del usuario
      idAreaUsuario: null,
      idEmpresaUsuario: null,

      show: false,
      snackbar: false,
      y: "top",
      x: null,
      mode: "",
      timeout: 6000,
      text: "",
      search: "",
      casos: [],
      chatItem: [],
      idCaso: null,
      loadingObtenerCasos: false,
      dialog2: false,
      dialog3: false,
      dialog6: false,
      // --- para subir imágenes ---
      previewImages: [],
      selectedFiles: [],
      // --- fin imágenes ---
      idCasoActual: null,
      dialogHistorial: false,
      editedItem3: {
        Observaciones: "",
      },
      editedItem: {
        estado: "",
        observacion: "",
      },
      headers: [
        {
          text: "ESTADO",
          value: "semaforo",
          align: "center",
          class: "column",
          sortable: false,
          width: "110px",
        },
        {
          text: "ID",
          value: "cc_id_caso",
          align: "left",
          align: "center",
          class: "column",
        },
        {
          text: "NOMBRE",
          align: "left",
          value: "nombre",
          align: "center",
          class: "column",
        },
        {
          text: "IP",
          align: "left",
          value: "ip",
          align: "center",
          class: "column",
        },
        {
          text: "AREA",
          align: "left",
          value: "cc_nombre_area",
          align: "center",
          class: "column",
        },
        {
          text: "NOMBRE PUNTO",
          align: "left",
          value: "nombre_punto",
          align: "center",
          class: "column",
        },
        {
          text: "EMPRESA",
          value: "nombreEmpresa",
          align: "center",
          class: "column",
        },
        {
          text: "MUNICIPIO",
          value: "municipio",
          align: "center",
          class: "column",
        },
        {
          text: "PRIORIDAD",
          align: "left",
          value: "cc_prioridad_requerimiento",
          align: "center",
          class: "column",
        },
        {
          text: "FECHA/HORA APERTURA",
          align: "left",
          value: "fecha_inicio",
          align: "center",
          class: "column",
        },
        {
          text: "REQUERIMIENTO",
          align: "left",
          value: "cc_nombre_requerimiento",
          align: "center",
          class: "column",
        },
        {
          text: "ACCIONES",
          value: "action",
          align: "center",
          class: "column",
        },
        {
          text: "INFO. ASESOR",
          value: "cc_id_asesor",
          align: "center",
          class: "column",
        },
      ],
      headers2: [
        {
          text: "USUARIO",
          align: "left",
          value: "user",
          align: "center",
          class: "column",
        },
        {
          text: "MESSAGE",
          align: "left",
          value: "message",
          align: "center",
          class: "column",
        },
      ],
      defaultItem: [],
      editedIndex: -1,
      editedItem: [],
      requerimientosInfo: {},
      dialogEvidencias: false,
      dialogImagenCompleta: false,
      evidencias: [],
      cargandoEvidencias: false,
      imagenSeleccionada: "",
      idCasoActual: null,
      tiempoRestanteBackend: null,
      estadoCaso: 0,
      diasFestivos: [],
      casosSeleccionados: [],
      dialogAccionMasiva: false,
      accionSeleccionada: null,
      accionesMasivas: [
        {
          key: "reasignar",
          label: "Reasignar",
          icon: "mdi-account-switch",
          color: "blue lighten-2",
        },
        {
          key: "cerrar",
          label: "Cerrar",
          icon: "mdi-folder-remove-outline",
          color: "red lighten-2",
        },
        {
          key: "suspender",
          label: "Suspender",
          icon: "mdi-cog-clockwise",
          color: "green lighten-2",
        },
        {
          key: "anular",
          label: "Anular",
          icon: "mdi-folder-remove-outline",
          color: "grey lighten-1",
        },
      ],
      masivoObservaciones: "",
      masivoMotivo: "",
      masivoFechaSuspension: "",
      menuSusp: false,
      dialogAgregarObservacion: false,
      nuevaObservacion: "",
      casoSeleccionado: null,
      dialogHistorialObservaciones: false,
      objAsesor: {
        nombre: "",
        cedula: "",
        telefono: "",
        correo: "",
      },
      showDialogAsesor: false,
      // Propiedades para reasignación
      especialistasDisponibles: [],
      especialistaSeleccionado: null,
      observacionReasignacion: "",
      cargandoEspecialistas: false,
      // Propiedades para observaciones
      editedItem3: {
        Observaciones: "",
      },
      observacionesRules: [
        (v) => !!v || "El campo Observaciones es obligatorio",
        (v) => (v && !v.startsWith(" ")) || "No puede iniciar con un espacio",
        (v) =>
          (v && v.trim().length >= 4) || "Debe contener mínimo 4 caracteres",
      ],
    };
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "Permisos Aplicación"
        : "Editar Permisos";
    },
    isObservacionValida() {
      const obs = this.editedItem3.Observaciones;
      return obs && !obs.startsWith(" ") && obs.trim().length >= 4;
    },
    isObservacionMasivaValida() {
      const obs = this.masivoObservaciones;
      return obs && !obs.startsWith(" ") && obs.trim().length >= 4;
    },
    // 🟢 NUEVO: Casos filtrados por Gestión Humana
    casosFiltrados() {
      let casos = this.casos;
      
      // Aplicar filtro de Gestión Humana SOLO si es área 3, usuario de Facilisimo y no está en "todos"
      if (this.idAreaUsuario === 3 && this.idEmpresaUsuario === 1 && this.filtroGestionHumana !== "todos") {
        casos = casos.filter(caso => {
          const nombreReq = caso.cc_nombre_requerimiento || "";
          
          switch (this.filtroGestionHumana) {
            case "nomina":
              return nombreReq.toUpperCase().includes("NOMINA") ||
                     nombreReq.toUpperCase().includes("DESPRENDIBLES DE NOMINA") ||
                     nombreReq.toUpperCase().includes("CERTIFICADO LABORAL") || 
                     nombreReq.toUpperCase().includes("CAMBIO DE EPS O FONDO DE PENSION");
            case "bienestar":
              return nombreReq.toUpperCase().includes("BIENESTAR") || 
                     nombreReq.toUpperCase().includes("PROCESOS DISCIPLINARIOS") || 
                     nombreReq.toUpperCase().includes("ACTIVIDADES BIENESTAR SOCIAL") || 
                     nombreReq.toUpperCase().includes("ACTIVIDADES NIÑOS");
            case "sst":
              return nombreReq.toUpperCase().includes("SST") || 
                     nombreReq.toUpperCase().includes("ACCIDENTE DE TRABAJO") || 
                     nombreReq.toUpperCase().includes("INSPECCION DE PUESTO DE TRABAJO") || 
                     nombreReq.toUpperCase().includes("SOLICITUD DE BOTIQUIN") || 
                     nombreReq.toUpperCase().includes("SOLICITUD DE CITA CON PSICOLOGO") || 
                     nombreReq.toUpperCase().includes("SOLICITUD DE CITA MEDICA") || 
                     nombreReq.toUpperCase().includes("SOLICITUD DE COMITE CONVIVENCIA LABORAL");
            case "capacitacion":
              return nombreReq.toUpperCase().includes("CAPACITACION") ||
                      nombreReq.toUpperCase().includes("SOLICITUD DE CAPACITACIONES") || 
                      nombreReq.toUpperCase().includes("SOLICITUD REINDUCCION") || 
                      nombreReq.toUpperCase().includes("CREACION DE USUARIOS UNIVERSIDAD CORPORATIVA") || 
                      nombreReq.toUpperCase().includes("ACTIVACION DE USUARIO TREBOL DEL SABER") || 
                      nombreReq.toUpperCase().includes("SOLICITUD DE CARNET") || 
                      nombreReq.toUpperCase().includes("SOLICITUD DE CHALECO") || 
                      nombreReq.toUpperCase().includes("POSTULACION VACANTE");
            default:
              return true;
          }
        });
      }
      
      return casos;
    },
  },

  async mounted() {
    await this.cargarDiasFestivos();
    await this.cargarEspecialistas();
    await this.obtenerIdAreaUsuario();
    await this.obtenerIdEmpresaUsuario();
    this.obtenerCasos();
    setInterval(() => {
      this.obtenerCasos();
    }, 60000);
  },

  methods: {
    // 🟢 NUEVO: Aplicar filtro de Gestión Humana
    aplicarFiltroGestionHumana() {
      this.$forceUpdate();
    },

    // 🟢 NUEVO: Obtener idArea del usuario
    async obtenerIdAreaUsuario() {
      try {
        const idUsuario = localStorage.getItem("id");
        const response = await axios.get(
          `${env.endpoint}user/infoUsuario?id=${idUsuario}`,
        );
        if (response.data && response.data.idArea) {
          this.idAreaUsuario = parseInt(response.data.idArea);
        }
      } catch (error) {
        console.error("Error obteniendo idArea del usuario:", error);
        const idArea = localStorage.getItem("idArea");
        if (idArea) {
          this.idAreaUsuario = parseInt(idArea);
        }
      }
    },

    // 🟢 NUEVO: Obtener idEmpresa del usuario
    async obtenerIdEmpresaUsuario() {
      try {
        const idUsuario = localStorage.getItem("id");
        const response = await axios.get(
          `${env.endpoint}user/infoUsuario?id=${idUsuario}`,
        );
        if (response.data && response.data.idEmpresa) {
          this.idEmpresaUsuario = parseInt(response.data.idEmpresa);
        }
      } catch (error) {
        console.error("Error obteniendo idEmpresa del usuario:", error);
      }
    },

    // Método para cambiar de vista
    changeFilter() {
      // Emitir evento para que el componente padre maneje la navegación
      this.$emit("change-view", this.selectedFilter);
    },
    selectFilterOption(value) {
      this.selectedFilter = value;
      this.showFilterMenu = false;
      this.$emit("change-view", value);
    },

    // Metodo para obtener todos lo incidentes pendientes
    async obtenerCasos() {
      this.loadingObtenerCasos = true;
      // Obtener datos de requerimientos primero
      const idUsuario = localStorage.getItem("id");
      const resReq = await axios.get(
        `${env.endpoint}callcenter/requerimientostodos?idUsuario=${idUsuario}`,
      );
      this.requerimientosInfo = {};
      resReq.data.forEach((req) => {
        this.requerimientosInfo[req.cc_id_requerimientos] = req;
      });

      // Obtener casos asignados
      const res = await axios.get(
        `${
          env.endpoint
        }callcenter/incidentesasignados?id=${localStorage.getItem("id")}`,
      );

      // CAMBIO: uso de endpoint agrupado para tiempos restantes
      const ids = res.data.map((caso) => caso.cc_id_caso);
      let tiempos = [];
      if (ids.length > 0) {
        try {
          const resp = await axios.post(
            `${env.endpoint}callcenter/tiemposRestantes`,
            { ids },
          );
          if (resp.data.estado) {
            tiempos = resp.data.resultados;
          }
        } catch (e) {
          console.error("Error obteniendo tiempos agrupados:", e);
        }
      }

      // Asignar colores y tiempos a cada caso
      for (let i = 0; i < res.data.length; i++) {
        // Configurar colores de prioridad
        res.data[i].color = this.getPriorityColor(
          res.data[i].cc_prioridad_requerimiento,
        );

        // Asignar tiempo y estado desde el array agrupado
        const tiempo = tiempos.find((t) => t.idCaso === res.data[i].cc_id_caso);
        if (tiempo) {
          res.data[i].tiempoRestanteBackend = tiempo.tiempo_restante;
          res.data[i].estado_caso = Number(tiempo.estado_caso);
        }
      }

      // ✅ FILTRAR CASOS CERRADOS: No mostrar casos con cerrados=1 (solucionados)
      // Solo mostrar casos asignados activos (cerrados=0, 2, 3, 4, 5)
      const casosActivos = res.data.filter((caso) => Number(caso.cerrados) !== 1);
      casosActivos.sort((a, b) => {
        const fA = a.fecha_inicio || "";
        const fB = b.fecha_inicio || "";
        return fA.localeCompare(fB);
      });
      this.casos = casosActivos;
      this.loadingObtenerCasos = false;
    },

    ingresarChat(item) {
      (this.idCaso = item.cc_id_caso),
        localStorage.setItem("sala", this.idCaso),
        this.$router.push("/Callcenter/Especialista/Chat-Especialista");
    },
    /**
     * Metodo que habilita la modal y setea la conversacion que viene en el item de la tabla
     */
    verConversacion(item) {
      this.dialog2 = true;
      this.idCasoActual = item.cc_id_caso;
      const data = JSON.parse(JSON.stringify(item));
      this.chatItem = JSON.parse(data.conversacion);
    },

    /**
     * Metodo para cerrar la modal de ver conversacion
     */
    close2() {
      this.dialog2 = false;
      setTimeout(() => {
        this.editedItem = this.defaultItem;
        this.editedIndex = -1;
      }, 300);
    },
    close3() {
      this.dialog3 = false;
      this.previewImage = null;
      this.filesToUpload = null;
      // Limpiar archivos seleccionados y previews al cerrar el modal
      this.selectedFiles = [];
      this.previewImages = [];
      if (this.$refs && this.$refs.fileInput) this.$refs.fileInput.value = null;

      setTimeout(() => {
        this.idCaso = null;
        this.editedIndex = -1;
        this.editedItem3 = { Observaciones: "" };
      }, 300);
    },
    close6() {
      this.dialog6 = false;
      setTimeout(() => {
        this.editedItem = {
          estado: "",
          observacion: "",
        };
        this.especialistaSeleccionado = null;
        this.observacionReasignacion = "";
        this.editedIndex = -1;
      }, 300);
    },
    save3(idCaso) {
      // Limpiar las observaciones antes de enviar
      const observacionesLimpias = this.sanitizeText(
        this.editedItem3.Observaciones,
      );

      const Observaciones = JSON.stringify({
        idEspecialista: localStorage.getItem("id"),
        cerrados: "1",
        oculto: "1",
        Observaciones: observacionesLimpias,
      });

      //SI ahi foto sube foto del cso
      this.uploadFilesMasivo(idCaso, this.selectedFiles);

      // Limpiar selección de archivos y previews luego de enviar
      this.selectedFiles = [];
      this.previewImages = [];
      if (this.$refs && this.$refs.fileInput) this.$refs.fileInput.value = null;

      axios
        .get(
          `${env.endpoint}callcenter/cerrar_caso?caso=${idCaso}&Observaciones=${Observaciones}`,
        )
        .then((res) => {
          if (res.data.mensaje === "caso cerrado correctamente") {
            this.text = "Caso cerrado correctamente";
            this.snackbar = true;

            // ACTUALIZACIÓN INMEDIATA: Remover el caso de la lista local
            this.casos = this.casos.filter((caso) => caso.cc_id_caso != idCaso);

            //registro historial
            axios.post(`${env.endpoint}historial/registrar_accion`, {
              cc_id_caso: idCaso,
              accion: 3, // 3 = Caso cerrado (según tu modelo)
              idUsuario: localStorage.getItem("id"),
              observaciones: observacionesLimpias,
            });
          } else {
            this.text = "No tienes permiso para cerrar este caso";
            this.snackbar = true;
          }
        });
      this.close3();

      // 🆕 SOLO recargar si estamos viendo la vista de cerrados
      // Ya actualizamos la lista local, no necesitamos recargar todo
      if (this.selectedFilter === "cerrados") {
        setTimeout(() => {
          this.obtenerCasos();
        }, 1000); // Delay más largo para dar tiempo al backend
      }
    },
    async guardarEstado() {
      if (this.editedItem.estado === "REASIGNAR") {
        // Manejar reasignación desde el modal de cambiar estado
        if (!this.especialistaSeleccionado) {
          this.text = "Debe seleccionar un especialista";
          this.snackbar = true;
          return;
        }

        try {
          // Primero desasignar el caso actual
          await axios.get(
            `${env.endpoint}callcenter/deshacerasignado?idCaso=${this.idCaso}`,
          );

          // Luego asignar al nuevo especialista
          const res = await axios.get(
            `${env.endpoint}callcenter/asignar_caso?id=${this.especialistaSeleccionado}&caso=${this.idCaso}`,
          );

          if (res.data.mensaje === "caso asignado correctamente") {
            // Obtener nombre del especialista asignado
            const especialista = this.especialistasDisponibles.find(
              (e) => e.idUsuario === this.especialistaSeleccionado,
            );
            const nombreEspecialista = especialista
              ? especialista.nombre
              : this.especialistaSeleccionado;

            // Limpiar observación antes de enviar
            const observacionLimpia = this.sanitizeText(
              this.observacionReasignacion,
            );

            // Registrar en historial
            await axios.post(`${env.endpoint}historial/registrar_accion`, {
              cc_id_caso: this.idCaso,
              accion: 11, // Código para reasignación
              idUsuario: localStorage.getItem("id"),
              observaciones: `Caso reasignado a ${nombreEspecialista}. ${observacionLimpia}`,
            });

            this.text = `Caso reasignado correctamente a ${nombreEspecialista}`;
            this.snackbar = true;
          } else {
            this.text = "Error al reasignar el caso";
            this.snackbar = true;
          }
        } catch (error) {
          console.error("Error en reasignación:", error);
          this.text = "Error al reasignar el caso";
          this.snackbar = true;
        }
      } else if (this.editedItem.estado === "DESASIGNAR") {
        // Manejar desasignación
        const observacionLimpia = this.sanitizeText(
          this.observacionReasignacion,
        );
        try {
          await axios.get(
            `${env.endpoint}callcenter/deshacerasignado?idCaso=${this.idCaso}`,
          );
          await axios.post(`${env.endpoint}historial/registrar_accion`, {
            cc_id_caso: this.idCaso,
            accion: 9, // Código para desasignación
            idUsuario: localStorage.getItem("id"),
            observaciones: observacionLimpia,
          });
          this.text = "Caso desasignado correctamente";
          this.snackbar = true;
        } catch (error) {
          console.error("Error en desasignación:", error);
          this.text = "Error al desasignar el caso";
          this.snackbar = true;
        }
      } else {
        // Manejar otros estados (suspender/anular)
        const observacionLimpia = this.sanitizeText(
          this.editedItem.observacion,
        );

        const estadosMap = {
          SUSPENDIDO: { estadoNumero: 3, accion: 6 },
          ANULADO: { estadoNumero: 5, accion: 8 },
        };

        const { estadoNumero, accion } = estadosMap[this.editedItem.estado];
        const observacion = encodeURIComponent(observacionLimpia || "");

        // Si es suspensión, agrega la fecha actual
        let urlEndpoint = `${env.endpoint}callcenter/cambiarEstado?idCaso=${this.idCaso}&cerrados=${estadoNumero}&observacion=${observacion}`;
        if (this.editedItem.estado === "SUSPENDIDO") {
          const fechaActual = new Date()
            .toISOString()
            .slice(0, 19)
            .replace("T", " ");
          urlEndpoint += `&fecha_suspension=${fechaActual}`;
        }

        axios
          .get(urlEndpoint)
          .then((res) => {
            if (res.data.estado) {
              this.text = "Estado cambiado correctamente";
              this.snackbar = true;
              // Registrar la acción en el historial
              axios
                .post(`${env.endpoint}historial/registrar_accion`, {
                  cc_id_caso: this.idCaso,
                  accion: accion,
                  idUsuario: localStorage.getItem("id"),
                  observaciones: observacionLimpia || "",
                })
                .catch((error) => {
                  console.error(
                    "Error al registrar la acción en el historial:",
                    error,
                  );
                });
            } else {
              this.text = "Este caso no pudo cambiar de estado";
              this.snackbar = true;
            }
          })
          .catch((error) => {
            console.error("Error al cambiar estado:", error);
            this.text = "Error al cambiar estado";
            this.snackbar = true;
          });
      }

      this.close6();
      setTimeout(() => {
        this.obtenerCasos();
      }, 500);
    },

    cambiarEstado(item) {
      this.editedItem = { ...item };
      this.dialog6 = true;
      this.idCaso = item.cc_id_caso;
    },
    /**
     * Metodo para cerrar la modal de ver conversacion
     */
    cerrarCaso(item) {
      this.idCaso = item.cc_id_caso;
      this.editedItem3.Observaciones = "";
      this.dialog3 = true;
    },
    verHistorial(item) {
      this.idCasoActual = item.cc_id_caso;
      this.dialogHistorial = true;
    },
    // Métodos para subir imágenes (igual que en Pendientes.vue)
    handleDropMultiple(event) {
      event.preventDefault();
      if (event.dataTransfer.files.length > 0) {
        this.addFiles(Array.from(event.dataTransfer.files));
      }
    },
    handlePasteMultiple(event) {
      event.preventDefault();
      const items = (event.clipboardData || event.originalEvent.clipboardData)
        .items;
      let files = [];
      for (const item of items) {
        if (item.kind === "file") {
          const file = item.getAsFile();
          files.push(file);
        }
      }
      if (files.length) {
        this.addFiles(files);
      }
    },
    handleFileChangeMultiple() {
      const files = Array.from(this.$refs.fileInput.files);
      if (files.length > 0) {
        this.addFiles(files);
      }
    },
    openFileInput() {
      this.$refs.fileInput.click();
    },
    addFiles(files) {
      // Limitar a máximo 5 archivos
      const total = this.selectedFiles.length + files.length;
      let filesToAdd = files;
      if (total > 5) {
        const allowed = 5 - this.selectedFiles.length;
        filesToAdd = files.slice(0, allowed);
        this.text = "Solo puedes subir hasta 5 archivos.";
        this.snackbar = true;
      }
      filesToAdd.forEach((file) => {
        if (this.isImageFile(file)) {
          const reader = new FileReader();
          reader.onload = (event) => {
            this.previewImages.push(event.target.result);
          };
          reader.readAsDataURL(file);
        }
        this.selectedFiles.push(file);
      });
    },
    isImageFile(file) {
      return file.type.startsWith("image/");
    },
    uploadFiles(idCaso, filesToUpload) {
      if (filesToUpload && filesToUpload.length > 0) {
        const formData = new FormData();
        for (let i = 0; i < filesToUpload.length; i++) {
          formData.append("evidencias[]", filesToUpload[i]);
        }
        formData.append("cc_id_caso", idCaso);
        axios
          .post(`${env.endpointEvidenciasCaso}`, formData)
          .then((response) => {
            // archivos subidos
          })
          .catch((error) => {
            console.error(error);
          });
      }
    },
    /**
     * Método para obtener y mostrar las evidencias de un caso
     */
    verEvidencias(idCaso) {
      this.idCasoActual = idCaso;
      this.dialogEvidencias = true;
      this.cargandoEvidencias = false;
      this.evidencias = [];

      // enpoint para traer imagenes al modal chat
      axios
        .get(`${env.endpointTraerEvidencias}?cc_id_caso=${idCaso}`)
        .then((response) => {
          this.evidencias = response.data.evidencias;
          // console.log(response.data.evidencias);
        })
        .catch((error) => {
          console.error("Error al cargar evidencias:", error);
          this.text = "Error al cargar las evidencias";
          this.snackbar = true;
        })
        .finally(() => {
          this.cargandoEvidencias = false;
        });
    },

    /**
     * Método para cerrar el modal de evidencias
     */
    closeEvidencias() {
      this.dialogEvidencias = false;
      this.evidencias = [];
    },

    /**
     * Método para ver una imagen en pantalla completa
     */
    verImagenCompleta(url) {
      this.imagenSeleccionada = url;
      this.dialogImagenCompleta = true;
    },

    isImageUrl(url) {
      if (!url) return false;
      return /\.(jpeg|jpg|gif|png|webp|svg)$/i.test(url);
    },
    getFileName(url) {
      if (!url) return "Archivo";
      try {
        const fullPath = new URL(url).pathname;
        return fullPath.substring(fullPath.lastIndexOf("/") + 1);
      } catch (e) {
        // Fallback for relative paths or simple filenames
        const parts = url.split("/");
        return parts[parts.length - 1] || "Archivo";
      }
    },
    downloadFile(url) {
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", this.getFileName(url));
      // link.setAttribute('target', '_blank'); // Opens in new tab, useful for some file types or if download attribute is not honored
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    /**
     * Método para descargar la imagen seleccionada
     */
    descargarImagen() {
      const link = document.createElement("a");
      link.href = this.imagenSeleccionada;
      link.download = this.imagenSeleccionada.split("/").pop();
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      this.downloadFile(this.imagenSeleccionada);
    },

    /**
     * Método para formatear la fecha de la evidencia
     */
    formatDate(dateString) {
      const options = {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      };
      return new Date(dateString).toLocaleDateString("es-ES", options);
    },
    getPriorityColor(priority) {
      switch (priority) {
        case "1":
          return "green";
        case "2":
          return "orange";
        default:
          return "red";
      }
    },

    handleCasoVencido({ idCaso, mensaje }) {
      this.text = mensaje;
      this.snackbar = false;

      const caso = this.casos.find((c) => c.cc_id_caso == idCaso);
      if (caso) {
        caso.estado_caso = 4;
        caso.cerrados = 4;
      }
      setTimeout(() => this.obtenerCasos(), 1000);
    },

    async actualizarTiempoRestanteCaso(idCaso) {
      try {
        const resp = await axios.get(
          `${env.endpoint}callcenter/tiempoRestante?idCaso=${idCaso}`,
        );
        const caso = this.casos.find((c) => c.cc_id_caso == idCaso);
        if (caso) {
          caso.tiempoRestanteBackend = resp.data.tiempo_restante;
          caso.estado_caso = Number(caso.cerrados);
        }
      } catch (e) {
        console.error("Error actualizando tiempo:", e);
      }
    },

    async cargarDiasFestivos() {
      try {
        const anioActual = new Date().getFullYear();
        const anioSiguiente = anioActual + 1;
        const respuestaActual = await axios.get(
          `https://date.nager.at/api/v3/publicholidays/${anioActual}/CO`,
        );
        const respuestaSiguiente = await axios.get(
          `https://date.nager.at/api/v3/publicholidays/${anioSiguiente}/CO`,
        );
        this.diasFestivos = [
          ...respuestaActual.data,
          ...respuestaSiguiente.data,
        ].map((festivo) => ({
          fecha: new Date(festivo.date + "T00:00:00"),
          nombre: festivo.name,
        }));
      } catch (error) {
        // Si falla la API, dejar el array vacío o podrías cargar un respaldo aquí
        this.diasFestivos = [];
      }
    },
    abrirModalAccionMasiva() {
      this.dialogAccionMasiva = true;
      this.accionSeleccionada = null;
      this.masivoObservaciones = "";
      this.masivoMotivo = "";
      this.masivoFechaSuspension = "";
      this.especialistaSeleccionado = null;
      this.observacionReasignacion = "";
    },
    seleccionarAccionMasiva(key) {
      this.accionSeleccionada = key;
    },
    async confirmarAccionMasiva() {
      if (this.accionSeleccionada === "reasignar") {
        // Manejar reasignación masiva
        if (!this.especialistaSeleccionado) {
          this.text = "Debe seleccionar un especialista para reasignar";
          this.snackbar = true;
          return;
        }

        const ids = this.casosSeleccionados.map((caso) => caso.cc_id_caso);
        const observacionLimpia = this.sanitizeText(
          this.observacionReasignacion,
        );
        const especialista = this.especialistasDisponibles.find(
          (e) => e.idUsuario === this.especialistaSeleccionado,
        );
        const nombreEspecialista = especialista
          ? especialista.nombre
          : this.especialistaSeleccionado;

        try {
          let resultados = [];
          for (const idCaso of ids) {
            try {
              // Primero desasignar el caso
              await axios.get(
                `${env.endpoint}callcenter/deshacerasignado?idCaso=${idCaso}`,
              );

              // Luego asignar al nuevo especialista
              const res = await axios.get(
                `${env.endpoint}callcenter/asignar_caso?id=${this.especialistaSeleccionado}&caso=${idCaso}`,
              );

              if (res.data.mensaje === "caso asignado correctamente") {
                // Registrar en historial
                await axios.post(`${env.endpoint}historial/registrar_accion`, {
                  cc_id_caso: idCaso,
                  accion: 11, // Código para reasignación
                  idUsuario: localStorage.getItem("id"),
                  observaciones: `Caso reasignado a ${nombreEspecialista}. ${observacionLimpia}`,
                });
                resultados.push({
                  idCaso,
                  estado: true,
                  mensaje: "Reasignado correctamente",
                });
              } else {
                resultados.push({
                  idCaso,
                  estado: false,
                  mensaje: "Error al reasignar",
                });
              }
            } catch (error) {
              resultados.push({
                idCaso,
                estado: false,
                mensaje: "Error en el proceso",
              });
            }
          }

          const exitosos = resultados.filter((r) => r.estado).length;
          const total = resultados.length;

          if (exitosos === total) {
            this.text = `Todos los casos (${total}) reasignados correctamente a ${nombreEspecialista}`;
          } else {
            this.text = `${exitosos} de ${total} casos reasignados correctamente a ${nombreEspecialista}`;
          }
          this.snackbar = true;
        } catch (error) {
          this.text = "Error en la reasignación masiva";
          this.snackbar = true;
        }

        this.dialogAccionMasiva = false;
        this.casosSeleccionados = [];
        this.especialistaSeleccionado = null;
        this.observacionReasignacion = "";
        this.obtenerCasos();
        return;
      }

      // Resto de acciones masivas (cerrar, suspender, anular)
      const ids = this.casosSeleccionados.map((caso) => caso.cc_id_caso);
      let payload = { ids, accion: this.accionSeleccionada, data: {} };

      if (this.accionSeleccionada === "cerrar") {
        // Limpiar observaciones masivas antes de enviar
        const observacionesLimpias = this.sanitizeText(
          this.masivoObservaciones,
        );
        payload.data = {
          observaciones: observacionesLimpias,
          idEspecialista: localStorage.getItem("id"),
          bandera: 0,
          oculto: 1,
          cerrados: 1,
        };
      } else if (this.accionSeleccionada === "suspender") {
        // Limpiar motivo antes de enviar
        const motivoLimpio = this.sanitizeText(this.masivoMotivo);
        payload.data = {
          motivo: motivoLimpio,
          fecha_suspension: this.masivoFechaSuspension,
        };
      } else if (this.accionSeleccionada === "anular") {
        // Limpiar motivo antes de enviar
        const motivoLimpio = this.sanitizeText(this.masivoMotivo);
        payload.data = {
          motivo: motivoLimpio,
        };
      }

      try {
        const res = await axios.post(
          `${env.endpoint}callcenter/acciones_masivas`,
          payload,
        );
        if (res.data && res.data.resultados) {
          let mensaje = res.data.resultados
            .map((r) => `Caso #${r.idCaso}: ${r.mensaje}`)
            .join("\n");
          this.text = mensaje;
          this.snackbar = true;

          // REGISTRO HISTORIAL MASIVO
          let codigoAccionHistorial = 0;
          if (this.accionSeleccionada === "cerrar") codigoAccionHistorial = 3;
          if (this.accionSeleccionada === "suspender")
            codigoAccionHistorial = 6;
          if (this.accionSeleccionada === "anular") codigoAccionHistorial = 8;

          // Copiar los archivos seleccionados antes de iterar
          const filesToUpload = [...this.selectedFiles];
          res.data.resultados.forEach((r) => {
            if (r.estado) {
              const observacionesParaHistorial =
                this.accionSeleccionada === "cerrar"
                  ? this.sanitizeText(this.masivoObservaciones)
                  : this.sanitizeText(this.masivoMotivo);
              axios.post(`${env.endpoint}historial/registrar_accion`, {
                cc_id_caso: r.idCaso,
                accion: codigoAccionHistorial,
                idUsuario: localStorage.getItem("id"),
                observaciones: observacionesParaHistorial,
              });
              // Subir archivos si la acción es cerrar y hay seleccionados
              if (
                this.accionSeleccionada === "cerrar" &&
                filesToUpload.length
              ) {
                this.uploadFilesMasivo(r.idCaso, filesToUpload);
              }
            }
          });
          // Limpiar archivos seleccionados y previews después de la acción masiva
          this.selectedFiles = [];
          this.previewImages = [];
          if (this.$refs && this.$refs.fileInput) this.$refs.fileInput.value = null;

          this.dialogAccionMasiva = false;
          this.casosSeleccionados = [];
          this.obtenerCasos();
        }
      } catch (error) {
        this.text = "Error en la acción masiva";
        this.snackbar = true;
      }
    },

    // Subida masiva para cada caso
    uploadFilesMasivo(idCaso, files) {
      if (files && files.length > 0) {
        const formData = new FormData();
        for (let i = 0; i < files.length; i++) {
          formData.append("evidencias[]", files[i]);
        }
        formData.append("cc_id_caso", idCaso);
        axios
          .post(`${env.endpointEvidenciasCaso}`, formData)
          .then((response) => {
            // archivos subidos
          })
          .catch((error) => {
            console.error(error);
          });
      }
    },

    // Función para limpiar texto de caracteres especiales y emojis
    sanitizeText(text) {
      if (!text) return "";

      return (
        text
          // Remover emojis y símbolos especiales
          .replace(
            /[\u{1F600}-\u{1F64F}]|[\u{1F300}-\u{1F5FF}]|[\u{1F680}-\u{1F6FF}]|[\u{1F1E0}-\u{1F1FF}]|[\u{2600}-\u{26FF}]|[\u{2700}-\u{27BF}]/gu,
            "",
          )
          // Remover otros caracteres especiales pero mantener acentos y ñ
          .replace(/[^\w\s\u00C0-\u017F.,;:()\-\[\]]/g, "")
          // Normalizar espacios múltiples
          .replace(/\s+/g, " ")
          // Trim espacios al inicio y final
          .trim()
      );
    },
    abrirAgregarObservacion(item) {
      this.casoSeleccionado = item;
      this.nuevaObservacion = "";
      this.dialogAgregarObservacion = true;
    },
    async guardarObservacion() {
      if (!this.nuevaObservacion.trim()) return;
      await axios.post(`${env.endpoint}historial/registrar_accion`, {
        cc_id_caso: this.casoSeleccionado.cc_id_caso,
        accion: 10, // Código para observación libre
        idUsuario: localStorage.getItem("id"),
        observaciones: this.nuevaObservacion,
      });
      this.dialogAgregarObservacion = false;
      this.text = "Observación guardada";
      this.snackbar = true;
    },
    verHistorialObservaciones(item) {
      this.idCasoActual = item.cc_id_caso;
      this.dialogHistorialObservaciones = true;
    },
    handleAsesor(asesor) {
      this.objAsesor = {
        nombre: asesor.nombre,
        telefono: asesor.celular,
        correo: asesor.correo,
        cedula: asesor.cedula,
      };
      // console.log(this.objAsesor);
      this.showDialogAsesor = true;
    },

    // Métodos para reasignación
    async cargarEspecialistas() {
      try {
        this.cargandoEspecialistas = true;
        // Obtener el cargo del usuario actual
        const idCargo = localStorage.getItem("idCargo");
        const resEspecialistas = await axios.get(
          `${
            env.endpoint
          }callcenter/get_especialistas?idCargo=${idCargo}&idUsuario=${localStorage.getItem(
            "id",
          )}`,
        );
        this.especialistasDisponibles = resEspecialistas.data;
      } catch (error) {
        console.error("Error cargando especialistas:", error);
        this.text = "Error al cargar especialistas";
        this.snackbar = true;
      } finally {
        this.cargandoEspecialistas = false;
      }
    },
  },
};
</script>

<style scoped>
#drop-area {
  border: 2px dashed #111c3d;
  padding: 20px;
  text-align: center;
  margin-top: 10px;
}

.upload-button {
  background-color: #1d3c7f;
  color: whitesmoke;
  border: none;
  padding: 10px 20px;
  cursor: pointer;
  margin-top: 10px;
}

.acciones-masivas-btn {
  border-radius: 8px;
  letter-spacing: 1px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  margin-bottom: 8px;
}
.acciones-masivas-list {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 16px;
  justify-content: flex-start;
}
.accion-masiva-opcion {
  min-width: 150px;
  font-weight: bold;
  font-size: 16px;
  border-radius: 8px;
  transition: box-shadow 0.2s;
}
.accion-masiva-opcion--active {
  box-shadow: 0 0 0 3px #3945d0;
  background: #fffbe6 !important;
}

.chat-message {
  word-break: break-word;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  max-width: 100%;
}

@media (max-width: 599px) {
  .update-btn {
    min-width: auto !important;
    width: 40px !important;
    height: 40px !important;
    padding: 0 !important;
  }
}
</style>

<style>
.snackbar-superior {
  z-index: 9999 !important;
  position: fixed !important;
  top: 0 !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  width: auto !important;
  max-width: 90vw !important;
}
</style>
